<div class="system-storage-depo-container" [attr.data-automation-id]="automationId + '-container'"
    [resBusySpinner]="isBusy" message="Loading ...">
    <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
        (click)="openHelp()">
        <i class="fa fa-question"></i>
    </button>
    <div class="top-row" *ngIf="!systemStorageDepotExists">
        <label *ngIf="newStorageSystemSelected"
            [attr.data-automation-id]="automationId + '-system-storage-selection-message'">System Storage has not been
            selected for the Depot</label>
    </div>
    <div class="select-system-storage-depot-button" *ngIf="!systemStorageDepotExists">
        <button type="button" [attr.data-automation-id]="automationId + '-select-system-storage-depot-button'"
            class="secondary-button select-system-storage-depot-button"
            (click)="openSelectSystemStorageDepotModalPopup()" *ngIf="hasCreatePermissions">
            <i class="fa fa-plus sizing-icons"></i>Select System Storage for Depot ...
        </button>
    </div>
    <div class="top-row" *ngIf="systemStorageDepotExists">
        <span [attr.data-automation-id]="automationId + 'system-storage-depot-Name'">
            Name: {{ systemStorageDepot.depotName }}
        </span>
    </div>
    <div *ngIf="systemStorageDepotExists">
        <span [attr.data-automation-id]="automationId + 'system-storage-depot-directoryPath'">
            Path: {{ systemStorageDepot.directoryPath }}
        </span>
    </div>
</div>